import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PrintService } from '../../../services/print.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'print-step-3',
  styleUrls: ['../../wizard/wizard.component.scss', './step3.component.scss'],
  templateUrl: './step3.component.html',
})
export class PrintStep3Component implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() next;
  @Input() prev;

  public deliveryoptions;
  storyId;

  constructor(
    public printService: PrintService,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.printService.getDeliveryOptions(this.printService.storyId).subscribe(data => {
      this.deliveryoptions = data['results'];
      this.printService.specs.delivery_option_id =
        this.printService.specs.delivery_option_id ||
        this.deliveryoptions[0].id;
    });
    this.storyId = this.activatedRoute.snapshot.params.id;
  }

  selectOption(id) {
    this.printService.specs.delivery_option_id = id;
    this.firebaseService.logEvent('checkout_delivery_option_update', {
      print_order_id: this.printService.printOrder.id,
      story_id: this.printService.storyId,
      project_id: this.printService.projectId,
      delivery_option_id: id,
    });
  }

  isOptionSelected(id) {
    return this.printService.specs.delivery_option_id === id;
  }

  getEstimatedDate(option) {
    return moment(option.estimated_delivery_date).toDate();
  }

  submit() {
    this.firebaseService.logEvent('checkout_delivery_option_select', {
      story_id: this.printService.storyId,
      project_id: this.printService.projectId,
      delivery_option_id: this.printService.specs.delivery_option_id,
    });
    this.next();
  }
}
